/**
 * Completes BODi/Stream logout after a Shopify session has already ended,
 * then hands off to Customer Accounts logout so the redirect chain matches the
 * shop's sign-out link, or back to the current page when that URL is unavailable.
 */
(function () {
  const SIGNED_IN_KEY = 'bodi-shop-signed-in';
  const SSO_SKIP_KEY = 'bodi-sso-skip-once';

  if (window.self !== window.top || window.frameElement) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);

  if (
    urlParams.has('preview_theme_id') ||
    navigator.userAgent.includes('Shopify Screenshot') ||
    navigator.userAgent.includes('HeadlessChrome')
  ) {
    return;
  }

  const logoutBaseUrl = document.currentScript?.getAttribute('data-bodi-logout-url');

  if (!logoutBaseUrl) {
    return;
  }

  try {
    if (localStorage.getItem(SIGNED_IN_KEY) !== 'true') {
      return;
    }
  } catch (error) {
    return;
  }

  const getLogoutUrl = () => {
    // Falling back to the current page keeps BODi/Stream logout working on
    // stores where subscriptionsredirecturl (and so accountLogoutUrl) is unset.
    const redirectUrl = window.BODi?.configs?.accountLogoutUrl || window.location.href;

    try {
      const url = new URL(logoutBaseUrl);
      url.searchParams.set('redirectUrl', redirectUrl);
      return url.toString();
    } catch (error) {
      return null;
    }
  };

  const logoutUrl = getLogoutUrl();

  if (!logoutUrl) {
    return;
  }

  try {
    localStorage.removeItem(SIGNED_IN_KEY);
    sessionStorage.setItem(SSO_SKIP_KEY, 'true');
  } catch (error) {
    // Continue; BODi logout still needs to run.
  }

  window.BODi.globalLogoutInProgress = true;
  window.location.replace(logoutUrl);
})();
